/* eslint-disable consistent-return */
/* eslint-disable camelcase */

import { useMutation, useQueryClient } from 'react-query'
import useSuccess from '@hooks/useSuccess'
import useCloseDialog from '@hooks/useCloseDialog'
import { updateStore } from '@lib/axios/store'

const useUpdate = () => {
  const showSuccess = useSuccess('Sukses', 'Sukses Mengubah Paket')
  const closeDialog = useCloseDialog()
  const queryClient = useQueryClient()
  const mutation = useMutation(
    ({ id, status, package_id }) => updateStore(id, status, package_id)
  )

  return (data) => mutation.mutate(data, {
    onError: () => closeDialog(),
    onSuccess: () => {
      showSuccess()
      queryClient.invalidateQueries('saas-store')
    },
  })
}

export default useUpdate
